import { Banner } from 'src/components/Banner';
import { ButtonLink } from 'src/components/Link/Link';
import { links } from 'src/links';

export const SharedCTABlock = () => (
  <Banner
    heading="Ready to get started?"
    subHeading="Find out which recruitment software providers are connected with SEEK"
    actions={
      <>
        <ButtonLink
          tone="brandAccent"
          href={links.CONNECTED_PARTERS.path}
          tracking={links.CONNECTED_PARTERS.tracking}
        >
          I’m an employer
        </ButtonLink>

        <ButtonLink
          tone="neutral"
          href={links.INTEGRATION_REQUEST.path}
          tracking={links.INTEGRATION_REQUEST.tracking}
        >
          I’m an ATS
        </ButtonLink>
      </>
    }
  />
);
